import React from "react";
import { useLanguage } from "../LanguageProvider";

export default function MiertModuLive() {
  const { dict } = useLanguage();
  return (
    <>
      <h2 className="text-lg md:text-2xl font-bold text-secondary mt-4 mb-3">Rólunk – A HoppHomes története</h2>
      <p className="text-white text-base md:text-lg mb-5 leading-relaxed">
        A HoppHomes mögött álló anyavállalat immár több mint 20 éve van jelen az építőipari piacon.<br/>
        Magyarországon 22 saját telephelyen forgalmaz építőanyagokat, ezzel stabil és megbízható szereplője a magyar építőanyag-kereskedelemnek.
      </p>
      <h3 className="text-base md:text-xl font-semibold text-secondary mb-2 mt-4">Új irány, biztos alapokon</h3>
      <p className="text-white text-base md:text-lg mb-5 leading-relaxed">
        A tulajdonos 2024-es év elején egy izgalmas, jövőbe mutató döntést hozott:<br/>
        saját moduláris otthonok gyártásába kezdett a cég 35.000 négyzetméteres gyártótelepén.<br/>
        A projekt mögött nemcsak tapasztalat, hanem erőforrás is áll: a gyárban egyszerre 13 ház készülhet párhuzamosan,<br/>
        gyors ütemben és magas minőségi színvonalon.<br/>
        Ezen felül 600 háznak az alapanyaga megtalálható a telephelyén, ezzel biztosítva a jövőbeli árgaranciát és ügyfélbiztonságot.
      </p>
      <h3 className="text-base md:text-xl font-semibold text-secondary mb-2 mt-4">Miért válasszon minket?</h3>
      <p className="text-white text-base md:text-lg mb-5 leading-relaxed">
        Moduláris otthonainkat közvetlenül a gyártótól vásárolhatja meg, így kiemelkedően versenyképes árakon kínáljuk őket.<br/>
        A szükséges alapanyagokat közvetlen beszerzéssel szerezzük be,<br/>
        ráadásul a felhasznált építőanyagok mintegy 70%-át saját magunk gyártjuk.<br/>
        Ez nemcsak a költségeket csökkenti, hanem a folyamatos minőségellenőrzést és megbízhatóságot is garantálja.
      </p>
      <h3 className="text-base md:text-xl font-semibold text-secondary mb-2 mt-4">Küldetésünk</h3>
      <p className="text-white text-base md:text-lg mb-2 leading-relaxed">
        Célunk, hogy elérhetővé tegyük a minőségi, kényelmes és modern otthonokat mindazok számára,<br/>
        akik gyors, költséghatékony és fenntartható megoldást keresnek.<br/>
        A HoppHomes a jövő otthonait kínálja – okos megoldásokkal, megfizethetően, kompromisszumok nélkül.
      </p>
    </>
  );
}
